/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 15:54:55
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-30 09:30:57
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/tools.ts
 */
import { errCodesMap } from 'src/error/code';
import _ from 'lodash';
import { randomNumber } from 'src/tools/helper';
import {
  generateDefaultMockupImage,
  generateDefaultService,
  EnumCollapseId,
  generateDefaultCustomisationButton,
} from './common';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
// const convertSpecificError = (specificErr) => {
//   const _return = [];
//   Object.values(specificErr || {}).forEach((err: string[]) => {
//     _return.push(...(err || []));
//   });
//   return _return;
// };
const validateMockupImages = (data, isPrimary?) => {
  const _data = _.cloneDeep(data || {});
  const moduleErr = [];
  const specificErr = {
    intervalTimeError: [],
  };
  const { enabled, autoPlay, intervalTime, linkModules = [] } = _data;

  if (!enabled) {
    return {
      hasError: false,
      generalError: moduleErr,
      specificError: specificErr,
    };
  } else {
    // if ((caption || '').length === 0) {
    //   specificErr.captionError.push(errCodesMap['104311']);
    // }
    if (autoPlay && !intervalTime) {
      specificErr.intervalTimeError.push(errCodesMap['104311']);
    }
    if (linkModules.length === 0) {
      moduleErr.push(errCodesMap['999998']);
    }
    for (const image of linkModules) {
      const { linkImage, draggableId } = image;

      if (!(linkImage || {}).uuid) {
        specificErr[`${draggableId}ImageError`] = [errCodesMap['199221']];
        // moduleErr.push(errCodesMap['199221']);
        // break;
      }
    }

    return {
      hasError: moduleErr.concat(convertSpecificError(specificErr)).length > 0,
      generalError: moduleErr,
      specificError: specificErr,
    };
  }
};
const validateService = (data) => {
  const _data = _.cloneDeep(data || {});
  const specificErr = {
    selectedServiceUuidError: [],
  };
  const { selectedServiceUuid } = _data;

  if (!selectedServiceUuid) {
    specificErr.selectedServiceUuidError.push(errCodesMap['100003']);
  }

  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificErr,
  };
};

const validateCustomisationButton = (data, isPrimary?) => {
  const _data = _.cloneDeep(data || {});
  const generalError = [];
  const specificErr = {};
  specificErr['textError'] = [];
  const { text } = _data;

  if (!text) {
    specificErr['textError'].push(errCodesMap['999999']);
  }

  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

const convertDataFromServerToRedux = (data, isPrimary) => {
  const _mockupImage = generateDefaultMockupImage();
  const _service = generateDefaultService();
  const _customisationButton = generateDefaultCustomisationButton();
  const {
    salesChannelProduct,
    uuid,
    salesChannelProductCustomisation,
    salesChannelProductUuid,
    productServices,
    termAndConditions,
  } = data;
  const { salesChannelName } = salesChannelProduct || {};
  const _isNew = !uuid;
  const {
    enabled,
    selectedServiceUuid,
    termsAndConditionsUuid,
    mockupImage,
    customisationButton,
    uuid: salesChannelProductCustomisationUuid,
    hasError,
    translationEnabled = false,
  } = salesChannelProductCustomisation || {};

  const collapseOpen = {
    [EnumCollapseId.mockupImage]: false,
    [EnumCollapseId.service]: false,
    [EnumCollapseId.customisationButton]: false,
  };
  const collapseErrorMsgDisplay = {
    [EnumCollapseId.mockupImage]: { hasError: false, display: !_isNew },
    [EnumCollapseId.service]: { hasError: false, display: !_isNew },
    [EnumCollapseId.customisationButton]: { hasError: false, display: !_isNew },
  };

  const { linkModules, enabled: mockupEnabled } = mockupImage || {};

  const _linkModules = (linkModules || _mockupImage.linkModules).map((img) => {
    return { ...(img || {}), draggableId: randomNumber() };
  });
  const _m = { ...(mockupImage || _mockupImage), linkModules: _linkModules };

  const _customButton = customisationButton || _customisationButton;
  if (!_customButton.text) {
    _customButton.text = '专属定制服务';
  }
  if (enabled && hasError) {
    const { hasError: _mockupImagesHasErr } = validateMockupImages(_m);
    const { hasError: _mockCustomisationButtonErr } =
      validateCustomisationButton(_customButton);
    let flag = false;

    if (_mockupImagesHasErr && !flag && mockupEnabled) {
      flag = true;
      collapseOpen[EnumCollapseId.mockupImage] = true;
      collapseErrorMsgDisplay[EnumCollapseId.mockupImage].hasError = true;
    }
    if (_mockCustomisationButtonErr && !flag) {
      collapseOpen[EnumCollapseId.customisationButton] = true;
      collapseErrorMsgDisplay[EnumCollapseId.customisationButton].hasError =
        true;
    }
    if (isPrimary) {
      const { hasError: _serviceImagesHasErr } = validateService({
        selectedServiceUuid,
        termsAndConditionsUuid,
      });
      if (_serviceImagesHasErr && !flag) {
        flag = true;
        collapseOpen[EnumCollapseId.service] = true;
        collapseErrorMsgDisplay[EnumCollapseId.service].hasError = true;
      }
    }
  }

  return {
    enabled,
    mockupImage: _m,
    service: { selectedServiceUuid, termsAndConditionsUuid } || _service,
    customisationButton: _customButton,
    collapseOpen,
    collapseErrorMsgDisplay,
    salesChannelProductUuid,
    salesChannelProduct,
    salesChannelName,
    uuid,
    productServices,
    salesChannelProductCustomisationUuid,
    translationEnabled,
    tcs: termAndConditions,
    ...reduxUpdatedStatusControl,
  };
};

const validationWhenSubmit = (state, isPrimary) => {
  if (state.isDataValid) {
    return;
  } else {
    const { enabled: mockupEnabled } = state.mockupImage || {};
    const { hasError: _mockupImagesHasErr } = validateMockupImages(
      state.mockupImage,
    );
    let flag = false;

    if (_mockupImagesHasErr && !flag && mockupEnabled) {
      flag = true;
      state.collapseOpen[EnumCollapseId.mockupImage] = true;
    }
    if (isPrimary) {
      const { hasError: _serviceImagesHasErr } = validateService(state.service);
      if (_serviceImagesHasErr && !flag) {
        flag = true;
        state.collapseOpen[EnumCollapseId.service] = true;
      }
    }
    return;
  }
};

const convertDataFromReduxToServer = (state) => {
  const _state = _.cloneDeep(state);

  const {
    mockupImage,
    enabled,
    service,
    salesChannelProductCustomisationUuid,
    salesChannelProductUuid,
    customisationButton,
  } = _state;
  //console.log(uuid);
  const { enabled: mockupEnabled } = mockupImage || {};
  let _mockupImage = _.cloneDeep(mockupImage || {});
  if (!mockupEnabled || !enabled) {
    _mockupImage = { enabled: false };
  }
  return {
    mockupImage: { ..._mockupImage, moduleType: 'MockupImage' },
    uuid: salesChannelProductCustomisationUuid,
    ...service,
    customisationButton,
    salesChannelProductUuid,
    enabled,
  };
};

export {
  convertDataFromServerToRedux,
  validateMockupImages,
  validateService,
  convertDataFromReduxToServer,
  validationWhenSubmit,
  validateCustomisationButton,
};
